import { getMessages } from "@/i18n/runtime";
import type { WallRewardEffect } from "./wallChallengePolicy";

// Default numeric formatter for wall reward effect values. Mirrors the
// previous in-place wallView helper so multiply-effect rendering keeps its
// historical "integer when integer, otherwise 2 decimals" shape. Numeric
// reward operations share this so the wall card and future PlayLog UI present
// the same numeric form.
function formatWallRewardEffectNumber(value: number): string {
  if (!Number.isFinite(value)) return "1";
  if (Number.isInteger(value)) return value.toString();
  return value.toFixed(2);
}

export function formatWallRewardEffect(effect: WallRewardEffect): string {
  const messages = getMessages();
  if (effect.operation === "multiply") {
    const value = formatWallRewardEffectNumber(effect.value);
    return messages.wall.rewardEffectMultiplyFormat(value);
  }
  if (effect.operation === "add") {
    const value = formatWallRewardEffectNumber(effect.value);
    return messages.wall.rewardEffectAddFormat(value);
  }
  if (effect.operation === "replace-target") {
    return messages.wall.rewardEffectBuiltInOHovAutoTargetFormat(
      effect.builtInOHovAutoTargetHov,
    );
  }
  if (effect.operation === "propagate-ra-bonus") {
    if (!effect.acquired) return messages.wall.rewardEffectUnacquired;
    return messages.wall.rewardEffectRaPropagationInfluenceFormat(
      formatWallRewardEffectNumber(effect.value),
    );
  }
  return "";
}
